import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth, readReferral } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid, ...readReferral() });
        setToken(data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: data.user } });
      } catch {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/"), 1800);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-sam-navy text-sam-cream">
      <div className="text-center">
        {error ? <p className="text-lg">{error}</p> : (
          <>
            <Loader2 className="h-8 w-8 animate-spin mx-auto mb-3" />
            <p className="font-display text-lg">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
